module.exports = __webpack_public_path__ + "loading_splat.f60c5e375c9f41ca50c1";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workspace/NodeJs/cpk-frontend/src/assets/images/loading_splat.gif
// module id = ../../../../../src/assets/images/loading_splat.gif
// module chunks = styles